import { FC, useEffect, useState } from "react";
import ModalComponent from "../../shared/base-components/Modal";

// import { useTodoDeleteMutation } from './Customer.actions'
import { RESPONSE_CODE } from "../../shared/models/Types";
import { errorNotify, successNotify } from "../../shared/utils/notifications";
import { Col, Form, Row } from "reactstrap";
import { useCostDeleteMutation } from "./Expense.actions";
import { CostDeleteModalProps } from "./Expense.constants";
import { SubmitHandler, useForm } from "react-hook-form";
import Switch from "../../shared/base-components/Switch";

const CostDeleteModal: FC<CostDeleteModalProps> = ({
  userData,
  isModalOpen,
  toggle,
  mutate,
  categoryId,
}) => {
  const { control, handleSubmit } = useForm<any>();

  const { data, mutate: costDeleteMutate, isLoading } = useCostDeleteMutation();

  const [isActive, setIsActive] = useState<boolean>(true);

  const onSubmit: SubmitHandler<any> = (requestFormValues: any) => {
    costDeleteMutate({
      id: userData?.id,
      is_active: false,
      is_visible: isActive,
    });
  };

  useEffect(() => {
    if (data?.status === RESPONSE_CODE.SUCCESS_CODE) {
      successNotify("Gider başarılı bir şekilde silindi.");
      toggle();

      mutate({ id: categoryId });
    }

    if (data?.status === RESPONSE_CODE.ERROR) {
      errorNotify("Gider zaten silinmiş yada bir hata var.");
      toggle();

      mutate({ id: categoryId });
    }
  }, [data]);

  return (
    <ModalComponent
      header={"Gider Silme"}
      description={""}
      isOpen={isModalOpen}
      toggle={toggle}
    >
      <Form onSubmit={handleSubmit(onSubmit)} className="custom-form mt-4 pt-2">
        <Row>
          <Col lg={12}>
            <div className="text-center">
              <i
                className="mdi mdi-alert-circle-outline"
                style={{ fontSize: "5em", color: "orange" }}
              />
              <Row>
                <Col>
                  <h5 style={{ color: "green" }}>Rapordanda silinsin mi ? </h5>
                  <Switch
                    onChangeHandler={(e: any) => setIsActive(e)}
                    control={control}
                    name="is_visible"
                  />{" "}
                </Col>
              </Row>

              <h4>{"Gider silinecektir onaylıyormusunuz!"}</h4>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="text-center mt-3">
              <button
                disabled={isLoading}
                type="submit"
                className="btn btn-success btn-lg ms-2"
              >
                Evet Sil!
              </button>
              <button
                type="button"
                className="btn btn-danger btn-lg ms-2"
                onClick={toggle}
              >
                Çıkış
              </button>
            </div>
          </Col>
        </Row>
      </Form>
    </ModalComponent>
  );
};

export default CostDeleteModal;
